var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 0C4.486 0 0 4.4859 0 9.99994C0 15.514 4.486 20 9.99994 20C15.5139 20 19.9999 15.514 19.9999 9.99994C19.9999 4.4859 15.514 0 9.99994 0ZM15.7421 8.31086L9.45962 14.5933C9.19249 14.8604 8.8374 15.0075 8.45966 15.0075C8.08192 15.0075 7.72683 14.8604 7.4597 14.5933L4.2578 11.3914C3.99067 11.1243 3.84354 10.7692 3.84354 10.3914C3.84354 10.0136 3.99067 9.65851 4.2578 9.39138C4.52482 9.12425 4.87992 8.97712 5.25776 8.97712C5.6355 8.97712 5.9907 9.12425 6.25772 9.39149L8.45956 11.5932L13.7419 6.31083C14.0091 6.0437 14.3642 5.89668 14.7419 5.89668C15.1196 5.89668 15.4747 6.0437 15.7419 6.31083C16.2934 6.86242 16.2934 7.75949 15.7421 8.31086Z",
    fill: "#00AC6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedTickIcon);
export default __webpack_public_path__ + "static/media/selectedTickIcon.6c1879ff7b7bc94d70fd48274703a706.svg";
export { ForwardRef as ReactComponent };